export default "__VITE_ASSET__SECW7_9Y__"